<template>
<div class="box box-solid">
    <div class="box-body form-horizontal">
        <div class="form-group">
            <div class="col-sm-10">
                <div class="table-responsive p-0">
                    <table class="table table-hover text-nowrap text-center">
                        <thead>
                            <tr>
                                <th>타이틀</th>
                                <th>등록 이미지 개수</th>
                                <th>순서</th>
                                <th>삭제</th>
                            </tr>
                        </thead>
                        <tbody v-for="(oitem, idx) in fakeui" :key="idx">
                            <tr>
                                <!-- {{ oitem }} -->
                                <td class="linkcmp " @click="showstoreEditEVe(oitem,oitem.storeImages,oitem.imageId)"><span class="cls_click"><a class="cls_click">{{ oitem.title }}</a></span></td>
                                <td>{{ oitem.storeImages.length }}</td>
                                <td>
                                    <drop @drop="optionsort(idx, $event)">
                                        <drag class="btn btn-default btn-social-icon cursorMove" :transfer-data="{index:idx, mark:'option'}">
                                            <div style="font-size: 1.4rem;">
                                                <b-icon-arrows-expand></b-icon-arrows-expand>
                                            </div>
                                        </drag>
                                    </drop>
                                </td>
                                <td>
                                    <button type="button" class="btn btn-social-icon" @click="rmvoption(idx)" v-if="oitem.deleted">
                                        <div style="font-size: 1.4rem;">
                                            <b-icon-trash></b-icon-trash>
                                        </div>
                                    </button>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <div class="text-right">
                        <button class="btn top-right-button btn-outline-success mt-2" @click="storeImgAddItemModal">+ 항목추가</button>
                    </div>
                </div>
            </div>
        </div>

    </div>
    <div class="modal" :style="showstoreEdit && {'display': 'block'}" id="newww" ref="scrollEl">
        <div class="modal-dialog maxwid" ><!--.modal-dialog-scrollable-->
            <div class="modal-content">
                <div class="modal-header">{{ itemModalName }}</div>
                <div class="modal-body form-horizontal">
                    <div class="row">
                        <label class="col-sm-2">
                            타이틀 ＊
                        </label>
                        <div class="col-sm-10">
                            <select class="form-control newrenewalS" v-model="storeTitleSelect" :disabled="!addorEdit || directInput" @change="storeTitleChange">
                                <option value="0">선택</option>
                                <option value="인테리어">인테리어</option>
                                <option value="메뉴">메뉴</option>
                                <option value="익스테리어">익스테리어</option>
                                <option value="주차장">주차장</option>
                                <option value="부대시설">부대시설</option>
                            </select>
                            <label class="control-label">
                                직접입력
                                <input type="checkbox" :checked="directInput" v-model="directInput" :disabled="!addorEdit" style="margin-right:10px" @change="storeTitleChange" />
                            </label>
                            <label class="control-label">
                                <input v-if="directInput" type="text" maxlength="12" :disabled="!addorEdit" v-model="directInputWrit" class="form-control" style="max-width:300px;">
                            </label>
                            <!-- <button class="btn btn-default titex" @click="titleExist" v-if="addorEdit">중복체크</button> -->
                            <div class="titleWarningText">{{ titleWarningText }}</div>
                        </div>
                    </div>

                    <div class="row mt-2">
                        <label class="col-sm-2">타이틀 설명</label>
                        <div class="col-sm-10">
                            <!-- <input type="text" class="form-control height3" v-model="description"> -->
                            <b-form-textarea :rows="3" :max-rows="3" v-model="description" />
                        </div>
                    </div>
                    <div class="row mt-2">
                        <label class="col-sm-2">이미지 ＊</label>
                        <div class="col-sm-10">
                            <!-- <button class="btn top-right-button btn-outline-success" @click="detailImgModal(false)" type="button">+ 이미지 추가</button> -->
                            <div :class="!sctopClass ? 'ssioOn' : 'ssio'">
                                <div class="nenenen">
                                    <stroeImgUploda ref="stiu" :sortable="'hold'" :container="'STORE'" :compact="true" maxFiles @getFileData="getMainFile" :Reflect="ReflectVal" />
                                </div>
                            </div>
                            <!-- <p class="mt-2"><strong>미리보기</strong></p> -->
                            <!-- {{ detailImgArray.mainimg }} -->
                            <div class="new widdidi">
                                <b-form-group label="미리보기" class="weight600 mt-2">

                                    <transition-group name="list" tag="ul">
                                        <sub-image-content-viewer v-for="(subImage,idx) in detailImgArray.mainimg" :key="Number(subImage.num)" :index="idx" :data="subImage" @remove-sub-image-content="removeSubImageContent" @movemouse="movemouse" @descriptionChange="descriptionChange" />
                                    </transition-group>
                                </b-form-group>
                            </div>
                            <!-- <StoreFileUpLoad ref="prodaddimgs" v-for="(simg, sidx) in detailImgArray.mainimg" :key="sidx" :title="simg.title" :imgdes="simg.description" :images="simg.images" @editProd="showEditSubImage(simg, sidx)" @remove="emvsubimg(sidx)" @sortdown="sortdownsub(sidx)" @sortup="sortupsub(sidx)" /> -->
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-outline-primary" @click="showstoreEditClose">닫기</button>
                    <button type="button" class="btn btn-default btn-primary" @click="titleExist">{{ btnName }}</button>
                </div>
            </div>
        </div>
    </div>

    <!-- <div class="text-center">
        <b-button type="button" variant="primary" @click="storeImagesUpdate()">저장</b-button>
    </div> -->
</div>
</template>

<script>
import {
    Drag,
    Drop
} from "vue-drag-drop";
// import ProdImg from "./ProdImg";
import stroeImgUploda from "../../../components/Upload/stroeImgUploda.vue";
import SubImageContentViewer from "./SubImageContentViewer";
import {
    mapGetters,
    mapActions
} from "vuex";

import api from "../../../constants/api";
let WidgetCount = 0;
export default {
    created() {

    },
    destroyed() {
        window.removeEventListener('scroll', this.handleScroll);
    },
    mounted() {
        let target = document.getElementById('newww');
        target.addEventListener('scroll', (e) => {
          this.handleScroll(e.target.scrollTop)
        });
        this.userRole = this.currentUser.userRole.split('_')[0]
        this.refresh();

    },
    components: {
        Drag,
        Drop,
        stroeImgUploda,
        'sub-image-content-viewer': SubImageContentViewer,
    },
    data() {
        return {
            sctopClass: true,
            titleWarningText: '',
            btnName: '',
            ReflectVal: null,
            userRole: null,
            detailImgModalBtnType: false,
            overlap: false,
            fakeui: [],
            description: '',
            storeImglist: [],
            storeTitleSelect: '0',
            showstoreEdit: false,
            addorEdit: false,
            directInput: false,
            detailImg: false,
            itemModalName: "",
            prodimgVal: "",
            editsubimgidx: 0,
            detailImgArray: {
                mainimg: [],
            },
            edtoitem: {},
            directInputWrit: "",
            storeImages: {
                title: "", //서브 이미지 제목
                description: "", //서브 이미지 설명
                displayOrder: 1, //서브 이미지 배열 순서
                images: [] //
            },
            scroll: '',
        }
    },
    computed: {
        ...mapGetters(['currentUser', 'siteName'])
    },
    methods: {
        handleScroll(sctop) {
          if (sctop >= 200) {
                this.sctopClass = false;
            } else {
                this.sctopClass = true;
            }
            //ssio class 780~890 정도까지가 하단 푸터로 드래그 시 팅기는 현상
        },
        movemouse(drop, drag) {
            if (drag !== undefined) {
                if (drag.mark != 'subimgs') {
                    return;
                }
                var t_array = this.detailImgArray.mainimg;
                this.detailImgArray.mainimg = [];
                var b = t_array[drag.index];
                t_array[drag.index] = t_array[drop];
                t_array[drop] = b;
                this.detailImgArray.mainimg = t_array;
            }
        },
        descriptionChange(idx, descriptionkk) {
            this.detailImgArray.mainimg[idx].description = descriptionkk;
        },
        storeTitleChange() {
            this.overlap = false;

        },
        onRmvSubImg() {
            this.storeImages.images = [];
        },
        getMainFile(file) { //이미지 파일 목록 stroeImgUploda 에서 넘겨줌
            // this.fileForm.mainImageUrl = fileData
            console.log("getMainFile", file)

            if (file.length > 0) {
                file.forEach((el, idx) => {
                    let _url = el.azureUrl ? el.azureUrl : el.url;
                    this.storeImages.images = [{
                        'width': el.width,
                        'height': el.height,
                        'url': _url,
                        'azureUrl': _url,
                    }]
                    this.onAddsubImages();
                });

            } else {
                if (!Array.isArray(file)) {
                    let _url = file.azureUrl ? file.azureUrl : file.url;
                    this.storeImages.images = [{
                        'width': file.width,
                        'height': file.height,
                        'url': _url,
                        'azureUrl': _url,
                    }]
                    this.onAddsubImages();
                } else {
                    this.storeImages.images = null
                }

            }

        },

        titleExist() {
            // console.log(this.fakeui);
            if (this.btnName === '변경') {
                this.onMdfsubImages();
            } else {
                let titles = [];
                this.fakeui.forEach(el => {
                    titles.push(el.title)
                });
                let blank_pattern = /^\s+|\s+$/g;

                if (!this.directInput) {
                    if (this.storeTitleSelect === '0') {
                        this.titleWarningText = '타이틀을 선택해주세요.';
                        this.$refs.scrollEl.scrollTo(0, 0)
                        // alert('타이틀을 선택해주세요.');
                        return;
                    } else {
                        this.titleWarningText = '';
                    }
                } else {
                    if (this.directInputWrit === '') {
                        // alert('타이틀을 입력해주세요.');
                        this.titleWarningText = '타이틀을 입력해주세요.';
                        this.$refs.scrollEl.scrollTo(0, 0)
                        return;
                    } else {
                        this.titleWarningText = '';
                    }
                    if (this.directInputWrit.replace(blank_pattern, '') === "") {
                        // alert('공백만 입력되었습니다.');
                        this.titleWarningText = '공백만 입력되었습니다.';
                        this.$refs.scrollEl.scrollTo(0, 0)
                        return;
                    } else {
                        this.titleWarningText = '';
                    }
                }

                let title = this.directInput ? this.directInputWrit : this.storeTitleSelect;
                let nosavetitle = false;
                if (titles.includes(title)) {
                    nosavetitle = true;
                }
                let reqURL = ''
                if (this.userRole == "BRAND") {
                    reqURL = api.changeAPI(this.siteName, api.basicURL + api.shop.storeImgTitleExistBrd) + '?storeCode=' + this.$route.params.storeCode + '&titleName=' + title
                } else {
                    reqURL = api.changeAPI(this.siteName, api.basicURL + api.shop.storeImgTitleExistStr) + '?titleName=' + title
                }

                this.$http.get(reqURL, {
                    params: '',
                    headers: {
                        'Authorization': `Bearer ${this.currentUser.tokens.access.token}`
                    }
                }).then(res => {
                    if (res.data.code === "OK") {
                        if (res.data.data === true) {
                            // alert('중복된값입니다.');
                            this.overlap = '중복';
                            this.titleWarningText = '타이틀이 중복된 값입니다.';
                            this.$refs.scrollEl.scrollTo(0, 0)
                        } else {
                            // alert('사용가능합니다.');
                            this.overlap = '가능';
                            this.titleWarningText = '';
                          this.$emit('get-kakao-alert', 'STORE');
                        }

                    } else {
                        throw 400
                    }
                }).then(() => {

                    this.onMdfsubImages();
                }).catch(err => {});
            }
        },
        storeImagesUpdate() {
            let reqURL = ''
            if (this.userRole == "BRAND") {
                reqURL = api.changeAPI(this.siteName, api.basicURL + api.shop.storeImgUpdateBrd)
            } else {
                reqURL = api.changeAPI(this.siteName, api.basicURL + api.shop.storeImgUpdateStr)
            }
            const params = {
                images: this.fakeui,
                storeCode: this.$route.params.storeCode,
            }

            this.$http.post(reqURL, params, {
                headers: {
                    'Authorization': `Bearer ${this.currentUser.tokens.access.token}`
                }
            }).then(res => {
                if (res.data.code === "OK") {
                    alert('저장되었습니다.');
                    this.refresh();

                } else {
                    throw 400
                }
            }).catch(err => {
                alert(err.response.data.message);
            })
        },
        refresh() {
            let reqURL = ''
            if (this.userRole == "BRAND") {
                reqURL = api.changeAPI(this.siteName, api.basicURL + api.shop.storeImgListBrd) + '?storeCode=' + this.$route.params.storeCode
            } else {
                reqURL = api.changeAPI(this.siteName, api.basicURL + api.shop.storeImgListStr)
            }

            this.$http.get(reqURL, {
                params: '',
                headers: {
                    'Authorization': `Bearer ${this.currentUser.tokens.access.token}`
                }
            }).then(res => {
                if (res.data.code === "OK") {
                    this.fakeui = res.data.data.list;
                    //
                } else {
                    throw 400
                }
            }).catch(err => {

            })
        },
        storeTitleSelecteve() {
            if (this.addorEdit == true) {
                this.storeTitleSelect = '0';
            }
        },
        detailImgClose() {
            this.detailImg = false
        },
        optionsort(selidx, drag) {
            if (drag.mark != 'option') {
                return;
            }
            var t_array = this.fakeui; //기존 배열
            this.fakeui = []; //배열비우고
            var b = t_array[drag.index]; //드래그할배열 담고
            let newTrp = JSON.parse(JSON.stringify(t_array[selidx].priority)); //드래그해서 움직일 tr에 priority
            let existingTr = JSON.parse(JSON.stringify(b.priority)); //기존위치에 tr에 priority

            t_array[selidx].priority = existingTr; // priority 변경
            t_array[drag.index].priority = newTrp; //드래그 한 tr priority 변경
            t_array[drag.index] = t_array[selidx]; //드래그 한 tr
            t_array[selidx] = b; // 놓여질부분
            this.fakeui = t_array; //다시 생성
          this.$emit('get-kakao-alert', 'STORE');
            this.storeImagesUpdate();
        },
        rmvoption(ridx) {
            if (confirm("매장 이미지를 삭제 하시겠습니까?")) {
                this.fakeui.splice(ridx, 1);
                this.$emit('get-kakao-alert', 'STORE');
                this.storeImagesUpdate();
            }
        },
        showstoreEditEVe(oitem, storeImages, imgid) {
            this.showstoreEdit = true;
            this.itemModalName = "항목상세";
            this.btnName = '변경';
            this.titleWarningText = '';
            this.addorEdit = false;
            this.detailImgArray.mainimg = [];
            var new_images = oitem.storeImages.map((item) => {
                return item
            });
            oitem.storeImages.forEach((element, idx) => {
                this.detailImgArray.mainimg.push({
                    id: imgid,
                    new_images,
                    images: [element],
                    description: element.description,
                    title: element.title,
                    num: imgid + WidgetCount++
                });
            });
            // console.log(this.detailImgArray.mainimg)
            this.directInput = oitem.deleted;
            if (oitem.deleted) {
                this.directInputWrit = oitem.title;
            } else {
                this.storeTitleSelect = oitem.title;
            }
            this.description = oitem.description;
            this.edtoitem = oitem;
            this.storeTitleSelecteve();
        },
        showstoreEditClose() {
            this.showstoreEdit = false;
        },
        detailImgModal(val) {
            if (!val) {
                this.storeImages = {
                    title: "", //서브 이미지 제목
                    description: "", //서브 이미지 설명
                    displayOrder: 1, //서브 이미지 배열 순서
                    images: [] //
                };
                this.$refs.stiu.parentImgCopy([]);
            }
            this.detailImgModalBtnType = val;
            this.detailImg = true;
        },
        onstoreImages(idx, url, width, height) {

            this.storeImages.images = [{
                'url': url,
                'width': width,
                'height': height
            }]
        },
        onAddsubImages() { // 상세이미지 추가
            this.storeImages.displayOrder = this.detailImgArray.mainimg.length + 1;
            var new_images = this.storeImages.images.map((item) => {
                return item
            });

            if (new_images.length == 0) {
                alert("이미지를 추가하세요.");
                return;
            }
            this.detailImgArray.mainimg.push({
                id: this.detailImgArray.mainimg.length,
                num: this.detailImgArray.mainimg.length + 1,
                ...this.storeImages,
                images: new_images
            });
            // console.log(this.detailImgArray.mainimg)
            this.detailImgClose();
        },
        onEdtsubImages() { // 상세이미지 수정
            if (this.storeImages.images === null) {
                alert("이미지를 추가하세요.");
                return;
            }
            let new_images = this.storeImages.images.map((item) => {
                return item
            });
            if (new_images.length == 0) {
                alert("이미지를 추가하세요.");
                return;
            }
            this.detailImgArray.mainimg[this.editsubimgidx] = {
                // id:this.detailImgArray.mainimg.length,
                num: this.detailImgArray.mainimg[this.editsubimgidx].num,
                id: this.detailImgArray.mainimg[this.editsubimgidx].id,
                title: this.detailImgArray.mainimg[this.editsubimgidx].title,
                description: this.detailImgArray.mainimg[this.editsubimgidx].description,
                ...this.storeImages,
                images: new_images
            };
            this.detailImgClose();
        },
        onMdfsubImages() { // 상세이미지 추가 저장

            var new_images = this.detailImgArray.mainimg.map((item) => {
                return item
            });
            if (!this.detailImg && this.addorEdit) {
                // if (this.overlap === false) {
                //     alert('타이틀 중복체크를 해주세요.');
                //     return;
                // }
                if (this.overlap === '중복') {
                    this.titleWarningText = '타이틀이 중복된 값입니다.';
                    this.$refs.scrollEl.scrollTo(0, 0)
                    return;
                } else {
                    this.titleWarningText = '';
                }
                if (this.directInput == true) {
                    if (this.directInputWrit === "") {
                        this.titleWarningText = '타이틀을 적어주세요.';
                        this.$refs.scrollEl.scrollTo(0, 0)
                        // alert("타이틀을 적어주세요.");
                        return;
                    } else {
                        this.titleWarningText = '';
                    }
                } else if (this.storeTitleSelect == "0") {
                    // alert("타이틀을 선택해주세요.");
                    this.titleWarningText = '타이틀을 선택해주세요.';
                    this.$refs.scrollEl.scrollTo(0, 0)
                    return;
                } else {
                    this.titleWarningText = '';
                }
            }
            if (new_images.length == 0) {
                alert("이미지를 추가하세요.");
                return;
            }
            if (this.detailImg) {
                this.detailImgClose();
            } else {
                let newarray = [];
                this.detailImgArray.mainimg.forEach(el => {
                    newarray.push({
                        'url': el.images[0].url,
                        'width': el.images[0].width,
                        'height': el.images[0].height,
                        'description': el.description,
                    })
                });
                if (!this.addorEdit) {
                    // this.fakeui = [];
                    this.fakeui.forEach((el, idx) => {
                        if (el.imageId === this.edtoitem.imageId) {
                            el.storeImages = newarray;
                            el.title = this.directInput ? this.directInputWrit : this.storeTitleSelect;
                            el.description = this.description;
                            el.deleted = this.directInput;
                        }
                    });
                } else {
                    let priorityArr = [];
                    let newpriority = 0;
                    let newpNum = 0;
                    if (this.fakeui.length === 0) {
                        //배열이 0인경우는 신규 추가시는 길이 + 1 에러안뜸
                        newpNum = this.fakeui.length + 1
                    } else {
                        //우선순위 정해줄때 기존배열에 가장큰수보다 1증감시켜서 넣기
                        this.fakeui.forEach(el => {
                            priorityArr.push(el.priority)
                        });

                        var m = Math.max(...priorityArr);
                        newpriority = m;
                        newpNum = newpriority + 1
                    }

                    // console.log(newpriority);
                    this.fakeui.push({
                        "storeImages": newarray,
                        'title': this.directInput ? this.directInputWrit : this.storeTitleSelect,
                        'description': this.description,
                        'deleted': this.directInput,
                        'priority': newpNum,
                    });
                }
                // console.log(this.fakeui)
                this.storeImages = {
                    title: "", //서브 이미지 제목
                    description: "", //서브 이미지 설명
                    displayOrder: 1, //서브 이미지 배열 순서
                    images: [] //
                };

            }
            // this.editsubimgidx = -1;
            this.storeImagesUpdate();
            this.showstoreEditClose();

        },
        emvsubimg(ridx) {
            this.detailImgArray.mainimg.splice(ridx, 1);
        },
        storeImgAddItemModal() {
            this.showstoreEdit = true;
            this.itemModalName = "항목추가";
            this.btnName = '저장';
            this.titleWarningText = '';
            this.directInputWrit = '';
            this.addorEdit = true;
            this.directInput = false;
            this.description = '';
            this.detailImgArray.mainimg = [];
            this.storeImages = {
                title: "", //서브 이미지 제목
                description: "", //서브 이미지 설명
                displayOrder: 1, //서브 이미지 배열 순서
                images: [] //
            };

            this.storeTitleSelecteve();
        },

        /** 서브이미지 삭제 **********************************************************************************************/
        removeSubImageContent(subImageContentId) { //서브이미지 삭제
            this.detailImgArray.mainimg = this.detailImgArray.mainimg.filter(item => item.num !== subImageContentId)
        },

    }
}
</script>

<style scoped>
.mt-2 {
    margin-top: 20px;
}

.newrenewalS {
    width: auto;
    margin-left: 0px;
    display: inline-block;
    margin-right: 10px;
    vertical-align: middle;
}

th {
    background-color: #dee2e685;
}

.radio>label {
    margin-right: 10px;
}

.modal {
    background-color: #00000047;
    overflow: scroll;
    scroll-behavior: smooth;
}

.modal-footer {
    text-align: center;
}

.tbl_h200 {
    height: 200px;
    overflow: scroll;
}

.nav-tabs li a {
    cursor: pointer;
}

.col-inline {
    display: inline-flex;
    align-items: center;
}

.btn-selweek {
    background-color: #5B9BD5;
    color: #FFFFFF;
}

@media (min-width: 768px) {
    .sm-inline {
        display: flex;
    }
}

.redmsg {
    color: #ff0000;
}

.blurmsg {
    color: #0000ff;
}

.titex {
    background: #ebebeb;
    border: 1px solid #c7c7c7;
    border-radius: 0;
}

.cursorMove {
    cursor: move;
}

.titleWarningText {
    color: red;
}
.ssio {
  z-index: 3;
}
.ssioOn {
    position: sticky;
    width: 100%;
    max-width: 100%;
    z-index: 999;
    background: #fff;
    top: 0;
}

.new.widdidi {
    z-index: 1;
    position: relative;
}

.nenenen {
    min-height: 158px;
}
</style>
